import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { AdmissionListScreen } from 'screens/patient';

export default withPermissions(AdmissionListScreen, [
  GroupSecurity.EncounterRead,
  GroupSecurity.PatientRead,
  GroupSecurity.PatientReadAll,
]);
